/* eslint-disable complexity */
/* eslint-disable max-lines-per-function */
import { toNDigits } from '@mail/cross-sizes-utils';
import { userKeeper } from '@mail-core/dashboard';
import { isViewContentOnly } from 'appHelpers/settingsHelpers';
import { BPublicFile } from 'blocks-cloud/b-public-file/b-public-file';
import { BReactComponent } from 'blocks-cloud/b-react-component';
import Shove from 'blocks-cloud/shove/shove';
import ShovedPublicFile from 'blocks-cloud/shoved-public-file/shoved-public-file';
import features from 'Cloud/Application/Features';
import socialIconsStatistics from 'Cloud/Application/SocialIconsStatistics';
import config from 'Cloud/config';
import $ from 'jquery';
import { Uflr } from 'lib/uflr';
import { getFeatureABDisableAdsSnackbar, getFeatureNewAdFormat, getFeaturePdfConverter } from 'modules/features/features.selectors';
import { path } from 'ramda';
import { canCloneWeblink } from 'reactApp/appHelpers/appHelpers';
import { HIDE_ADS, IS_STOCK, IS_WEBVIEW } from 'reactApp/appHelpers/configHelpers';
import { toolbarActions } from 'reactApp/appHelpers/toolbarActions';
import { EPromoAction, sendPromoAnalytics } from 'reactApp/components/DisableAdsPromo/DisableAdsPromo.analytics';
import { SPACE_LIST } from 'reactApp/constants/spaceList';
import { isPreviewable } from 'reactApp/modules/file/utils';
import { getCurrentPublicItem } from 'reactApp/modules/public/public.selectors';
import { routeStatusPage } from 'reactApp/modules/router/router.module';
import { getCurrentStorage } from 'reactApp/modules/router/router.selectors';
import { snackbarController } from 'reactApp/modules/snackbar/snackbar.controller';
import { getStorageItemById } from 'reactApp/modules/storage/storage.selectors';
import { EStorageType } from 'reactApp/modules/storage/storage.types';
import { publishItem } from 'reactApp/modules/viewer/viewer.module';
import { EStatus } from 'reactApp/sections/ErrorPage/ErrorPage.types';
import { isReactMobilePublic } from 'reactApp/sections/MobilePublicPage/isReactMobilePublic';
import { store } from 'reactApp/store';
import { getAdvDisableLink } from 'reactApp/ui/AdvBanners/AdvBanners.helpers';
import { EButtonAction, sendDisableAdsAnalytics } from 'reactApp/ui/AdvBanners/DisableButton/DisableButton.analytics';
import { MobileDialog } from 'reactApp/ui/Mobile/MobileDialog/MobileDialog';
import { PublicFile } from 'reactApp/ui/Mobile/PublicFile/PublicFile';
import { ReactViewerComponent } from 'reactApp/ui/ReactViewer/ReactViewerComponent';
import { RollContentAds } from 'reactApp/ui/RollContent/RollContentAds';
import { ViewerToolbar } from 'reactApp/ui/ViewerToolbar/ViewerToolbar';
import { noop } from 'reactApp/utils/helpers';

// eslint-disable-next-line sonarjs/cognitive-complexity

const initDisableAdAnalytics = () => {
    const button = document.querySelector('.js-disable-button');
    const state = store.getState();
    const showDisableButton = getFeatureABDisableAdsSnackbar(state) !== 'b';
    const storage = getCurrentStorage(state);

    if (!button) {
        return;
    }

    sendDisableAdsAnalytics({
        action: EButtonAction.SHOW,
        place: 'left-col',
    });

    button.addEventListener('click', () => {
        sendDisableAdsAnalytics({
            action: EButtonAction.CLICK,
            place: 'left-col',
        });

        // tempexp_13536-start
        if (showDisableButton) {
            sendPromoAnalytics({
                action: EPromoAction.CLICK,
                name: 'disable-adv-button',
                source: storage,
                name_button: 'disable-adv',
            });
        }
        // tempexp_13536-end
    });
};

export default function (app) {
    if (!app.isPublic() || isReactMobilePublic || config.get('EDITOR')) {
        return;
    }

    const RB_SLOT_PARAM = app.getParam('RB_SLOT_PARAM');
    const IS_PUBLIC_SHOVE = app.getParam('PUBLIC_SHOVE');
    const PUBLIC_SHOVE_TIMEOUT = app.getParam('PUBLIC_SHOVE_TIMEOUT');
    const PUBLIC_SHOVE_SZ = app.getParam('PUBLIC_SHOVE_SZ');
    const MOBILE_BROWSER = app.getParam('MOBILE_BROWSER');
    const IS_IOS = app.getParam('IS_IOS');

    const IS_MOBILE_BROWSER = app.browser.isMobile();
    const IS_PHONE_BROWSER = app.browser.isPhone();
    const IS_TABLET_BROWSER = app.browser.isTablet();
    const IS_PUBLIC_FOLDER = app.isChoosedPublicFolder();
    const PREVIEW_MOD_TOUCH = MOBILE_BROWSER === 'IOS' || IS_IOS || MOBILE_BROWSER === 'ANDROID';

    const ANONYM_USER = config.get('ANONYM_USER');

    const IS_DARK_PUBLIC_VIEW_ENABLED = features.isFeature('dark-public-file') || IS_WEBVIEW || !IS_MOBILE_BROWSER;

    const freeloader =
        !app.user.isCorp() &&
        !app.user.isB2BUserCorp() &&
        (app.user.isOverquota() || (!config.get('PAID_USER') && app.user.getSpace().bytesUsed >= SPACE_LIST.gb_16));

    const isNotPreviewable = function (item) {
        return !PREVIEW_MOD_TOUCH || !isPreviewable(item) || app.isChoosedPublicFile();
    };

    let shovedContent;
    let shove;
    if (IS_PUBLIC_SHOVE) {
        shovedContent = new ShovedPublicFile({});
        const state = store.getState();
        const showDisableButton = getFeatureABDisableAdsSnackbar(state) !== 'b';

        shovedContent.on({
            download() {
                RADAR('ui_shove_download_file');
            },

            clone() {
                RADAR('ui_shove_clone_file');
            },
        });

        shove = new Shove({
            data: {
                type: IS_PUBLIC_FOLDER ? 'folder' : 'file',
                variant: PUBLIC_SHOVE_SZ,
                timeout: PUBLIC_SHOVE_TIMEOUT,
                preview: RB_SLOT_PARAM,
                // tempexp_13536-next-line
                showDisableButton,
                ...IS_PUBLIC_SHOVE,
            },
        });

        let shoveStartTime = Date.now();

        shove.on('render', function () {
            shoveStartTime = Date.now();

            const radar = RADAR.group('shove');

            radar.add('show');
            radar.add(`show_${HIDE_ADS ? 'noads' : 'ads'}`);

            if (IS_PUBLIC_FOLDER) {
                radar.add('show_folder');
            } else {
                radar.add('show_file');

                const item = app.current();

                if (item) {
                    const itemExt = item.ext;
                    const itemKind = item.subKind;

                    radar.add(`show_${itemKind}`);
                    radar.add(`show_${itemKind}_${itemExt}`);

                    if (isPreviewable(item)) {
                        // Вычисляем ошибочные срабатывания PUBLIC_SHOVE
                        radar.add('previewable');
                        radar.add(`previewable_${itemKind}`);
                        radar.add(`previewable_${itemKind}_${itemExt}`);
                    }
                }
            }

            radar.send();
        });

        shove.on({
            load(event, data) {
                const timeLeft = Date.now() - shoveStartTime;

                if (data.afterTimeout) {
                    RADAR('shove_frame_load-after-timeout', timeLeft);
                } else {
                    RADAR('shove_frame_load', timeLeft);
                }
            },

            timeout() {
                RADAR('shove_frame_timeout', Date.now() - shoveStartTime);
            },
        });
    }

    const getCurrentItem = function () {
        const state = store.getState();
        const storage = getCurrentStorage(state);

        const item = storage === EStorageType.stock ? app.current() : getCurrentPublicItem(state);

        return !IS_MOBILE_BROWSER && !app.isChoosedPublicFile() ? undefined : item;
    };

    // eslint-disable-next-line new-cap
    const content = new patron.toolkit['b-controls-group']({
        // eslint-disable-next-line sonarjs/no-duplicate-string
        el: '#public-file',
        template: 'app',
        templateBlock: 'public-file',

        onSocial(event, ui) {
            const item = getCurrentItem();

            app.social.publishItem(ui.id, item);

            socialIconsStatistics.send({
                item,
                platform: app.browser.getPlatform(),
                storage: app.getStorage(),
                sendKaktam: true,
                isFile: app.isChoosedPublicFile(),
                isShoved: IS_PUBLIC_SHOVE,
                service: ui.id,
                socialIconsView: 'content',
            });

            socialIconsStatistics.sendGoogleAnalytics({
                isFile: app.isChoosedPublicFile(),
                isAuthorized: app.user.isAuthorized(),
            });
        },

        onLinkAction(evt, ui) {
            const event = ui.event;

            if (!event.metaKey && !event.shiftKey && !event.ctrlKey && this.triggerDownload(evt, ui, 'link_action')) {
                event.preventDefault();
            }
            // else work as ordinary link
        },

        empty() {
            this.setData({});
            this.$el.empty();
        },
    });

    app.on('routeChangeEnd', function () {
        const item = getCurrentItem();

        if (Uflr.is(item) && IS_STOCK) {
            // CLOUDWEB-7677: Не показываем на публичных страницах illegal и blocked файлы.
            store.dispatch(routeStatusPage({ status: EStatus.NOT_FOUND }));
            return;
        }

        if (IS_PUBLIC_FOLDER && item && item.isFolder && item.own) {
            RADAR.ga('send', 'event', {
                eventCategory: 'public-own-f',
                eventAction: 'show',
                eventLabel: '',
            });
        }

        if (!IS_MOBILE_BROWSER) {
            RADAR.ga('send', 'event', {
                eventCategory: 'public-desk',
                eventAction: 'show',
                eventLabel: HIDE_ADS ? 'noads' : 'ads',
            });
        }

        initDisableAdAnalytics();

        if (item && !app.isFolder(item) && app.isChoosedPublicFile()) {
            if (item.ext2) {
                RADAR.ga('send', 'event', {
                    eventCategory: 'public',
                    eventAction: 'file-extention',
                    eventLabel: item.ext2,
                });
                RADAR.ga('send', 'event', {
                    eventCategory: 'public',
                    eventAction: 'file-type',
                    eventLabel: item.kind,
                });
            }

            if (IS_PUBLIC_SHOVE && shovedContent && shove) {
                shovedContent.renderTo('#shoved-public-file', item);
                shove.renderTo($('#public'));
            } else if (isNotPreviewable(item)) {
                const state = store.getState();
                const storage = getCurrentStorage(state);
                const showDisableButton = getFeatureABDisableAdsSnackbar(state) !== 'b';

                RADAR.ga('send', 'event', {
                    eventCategory: 'public-file-view',
                    eventAction: 'show',
                });

                if (!Uflr.is(item)) {
                    document.body.classList.add('public-file-large-view');
                }

                const bPublicFile = new BPublicFile({
                    el: $('<div/>'),
                    template: 'app',
                    renderMode: 'append',
                });

                bPublicFile.setData({
                    domIdWorm: app.getParam('DOM_ID_WORM'),
                    noads: HIDE_ADS || isViewContentOnly,
                    isAnonymous: app.getParam('ANONYM_USER'),
                    isPreviewable: isPreviewable(item),
                    // tempexp_13536-next-line
                    href: showDisableButton ? getAdvDisableLink({ isAnonymous: ANONYM_USER }) : undefined,
                });

                bPublicFile.renderTo('#public-file');

                $('.public__content__noads__top').removeClass('public__content__noads__top');
                $('.public__content__noads__label_top').removeClass('public__content__noads__label_top');

                const file = getStorageItemById(state, storage, storage === EStorageType.public ? item.weblink : item.stockId);

                const isPreviewableItem = isPreviewable(file);
                const viewerEl = document.querySelector('.js-b-public-file__viewer');

                if (!IS_PHONE_BROWSER) {
                    if (viewerEl) {
                        const viewer = new BReactComponent({
                            ReactComponent: ReactViewerComponent,
                            renderMode: 'append',
                        });

                        const props = {
                            isPublic: true,
                            isStock: storage === EStorageType.stock,
                            isMountedFolder: false,
                            showEditorHeader: false,
                            showBottomAds: !HIDE_ADS && !isViewContentOnly,
                            showLogo: true,
                            showNotify: noop,
                            showSnackbar: (data) => snackbarController.showSnackbar(data),
                            publishItemAction: (data) => store.dispatch(publishItem(data)),
                            gaCategory: 'indpnewv',
                            isViewer: true,
                            enablePreload: false,
                            onClose: noop,
                            embedded: true,
                            itemStorage: storage,
                            isPreviewableItem,
                            file,
                            itemCount: 1,
                            isNewAdFormat: getFeatureNewAdFormat(state),
                            pdfConverterEnabled: getFeaturePdfConverter(state, file),
                        };

                        viewer.renderTo(viewerEl, { props });
                    }

                    document.body.classList.add('public-file-large-view__new');
                    $('.public__content__row').remove();
                    if (!freeloader && isPreviewableItem) {
                        $('#public').addClass('public_no2col');
                    }
                } else {
                    if (viewerEl) {
                        const viewer = new BReactComponent({
                            ReactComponent: PublicFile,
                            renderMode: 'append',
                        });

                        viewer.renderTo(viewerEl, {
                            props: { file, storage }
                        });
                    }

                    $('.public').css({ backgroundColor: '#333333' });

                    const isAuthorized = app.user.isAuthorized();
                    const isPublic = storage === EStorageType.public;

                    const toolbarElement = document.querySelector('.js-react-toolbar');

                    if (toolbarElement && !isViewContentOnly) {
                        const reactToolbar = new BReactComponent({
                            ReactComponent: ViewerToolbar,
                            renderMode: 'append',
                        });

                        const props = {
                            file: {
                                name: item.isFolder ? item.name : item.nameWithoutExt,
                                size: toNDigits({bytes: item.size, maxDigitsCount: 3})?.value,
                                extension: item.ext,
                                date: item.mtime,
                                expires: item.weblinkExpires,
                            },
                            socialList: app.social.list.filter((social) => social.id !== 'email'),
                            canClone: canCloneWeblink(isAuthorized, storage),
                            onSocial: (id) => app.social.publishItem(id, item),
                            onDownload: (useDownloadUrl) => app.download(item.id, false, useDownloadUrl, isPublic ? storage : undefined),
                            onClone: () =>
                                toolbarActions.clone({
                                    id: item.id,
                                    destination: '',
                                    source: 'public-files',
                                }),
                            showFullScreen: path(['kind'], item) !== 'video',
                            onFullScreen: noop,
                            isPhone: IS_PHONE_BROWSER,
                            isMobile: IS_MOBILE_BROWSER,
                            isIOS: app.browser.isIOS(),
                            onLogin: () => app.ui.login.show(),
                            isAuthorized,
                            isPreviewableItem,
                        };

                        reactToolbar.renderTo(toolbarElement, { props });
                    }

                    if (!HIDE_ADS && !isViewContentOnly) {
                        let isMount = false;

                        const callback = (entry) => {
                            const [{ isIntersecting }] = entry;
                            const rollElement = document.querySelector('.js-react-roll-ads');

                            if (isIntersecting && !isMount && rollElement) {
                                isMount = true;

                                const reactRollContent = new BReactComponent({
                                    ReactComponent: RollContentAds,
                                    renderMode: 'append',
                                });

                                reactRollContent.renderTo(rollElement, {
                                    props: { darkMode: true, showElementIsInViewport: isIntersecting },
                                });
                            }
                        };

                        const observer = new IntersectionObserver(callback, {
                            root: null,
                            threshold: 1,
                        });

                        window.addEventListener('load', () => {
                            if (toolbarElement) {
                                setTimeout(() => observer.observe(toolbarElement), 100);
                            }
                        });
                    }
                }
                const viewerPlaceholder = document.querySelector('#viewerPlaceholder');
                if (viewerPlaceholder) {
                    viewerPlaceholder.style.display = 'none';
                }
            }
        } else if (IS_PUBLIC_SHOVE) {
            shove.renderTo($('#public'));
        }

        userKeeper.timeEnd('cloud-public-ready');
    });

    if (IS_MOBILE_BROWSER) {
        app.on('routeEnd', function () {
            const item = getCurrentItem();
            let $jsContentLayout;
            if (Uflr.is(item) && IS_STOCK) {
                // CLOUDWEB-7677: Не показываем на публичных страницах illegal и blocked файлы.
                store.dispatch(routeStatusPage({ status: EStatus.NOT_FOUND }));
                return;
            }

            if ((IS_PHONE_BROWSER || IS_TABLET_BROWSER) && item?.kind === 'document' && item?.weblinkAccessRights === 'rw') {
                RADAR(`public-mobile_openrw_${item.ext2}`);

                const reactDialog = new BReactComponent({
                    ReactComponent: MobileDialog,
                    renderMode: 'append',
                });

                reactDialog.renderTo($('.js-react-public-notify'), {
                    props: {
                        title: 'Редактирование недоступно в мобильном браузере',
                        text: 'Пожалуйста, откройте ссылку на вашем компьютере',
                        closableStateInside: true,
                        isTablet: IS_TABLET_BROWSER,
                        mod: 'mobileV1',
                    },
                });
                RADAR.ga('send', 'event', {
                    eventCategory: 'public-desk',
                    eventAction: 'show',
                    eventLabel: 'abnoads_yes',
                });
            }

            if ((IS_DARK_PUBLIC_VIEW_ENABLED && app.isChoosedPublicFile() && !IS_PUBLIC_FOLDER) || isReactMobilePublic) {
                return;
            }

            if (item && isNotPreviewable(item)) {
                $jsContentLayout = $('#public .js-content-layout');
                if (item.isFolder) {
                    app.setChoosedPublicFolder(true);

                    content.empty();

                    patron.toolkit.toggleMod(content.$el, 'hide', IS_PHONE_BROWSER);
                    patron.toolkit.toggleMod($jsContentLayout, 'phone', IS_PHONE_BROWSER);

                    app.ui?.datalist?.show();
                } else {
                    app.setChoosedPublicFolder(false);

                    const data = content.getData();
                    if (data && data.item !== item) {
                        // CLOUDWEB-3176
                        content.render(item);

                        patron.toolkit.toggleMod(content.$el, 'hide', false);
                        patron.toolkit.toggleMod($jsContentLayout, 'phone', false);
                    }

                    app.ui?.datalist?.hide();
                }
            }
        });
    }
}
